import axios from "axios";

export class Message {
  static type = {
    BLOQUEADO_PARCIALMENTE: "BLOQUEADO_PARCIALMENTE",
  };

  async getMessage(type) {
    try {
      const response = await axios.get(`/v2/getMessageByInterface/${type}/WEBSITE`);

      if (response.data.status.code) throw response.data;

      return response.data.Mensagem;
    } catch (error) {
      console.error(error);

      return {
        name: 'ERROR',
        message: 'Não foi possível carregar a mensagem.'
      };
    }
  }
}

const instance = new Message();

export default instance;



// WEBPACK FOOTER //
// ./src/services/message.js